import { render, staticRenderFns } from "./dialogue.vue?vue&type=template&id=d0ecd4d8"
import script from "./dialogue.vue?vue&type=script&lang=js"
export * from "./dialogue.vue?vue&type=script&lang=js"
import style0 from "./dialogue.vue?vue&type=style&index=0&id=d0ecd4d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports